import React from 'react';
import propTypes from 'prop-types';

import { capitalize } from '@common/utils/string';
import { Progressbar } from '@common/ui/general';

const headerText = [
  'Topic', 'Coverage', 'Problems Solved',
];

function ProblemStat({ topicStats, profileACL }) {
  const data = topicStats.map(topicElem => (
    { ...topicElem, topic: capitalize(topicElem.topic) }
  )).sort(((a, b) => (b.topic < a.topic ? 1 : -1)));
  function headerUI() {
    return (
      <thead className="profile-problem-stat__header">
        <tr>
          {headerText.map((e, idx) => (
            <th
              key={idx}
              className="profile-problem-stat__header-cell"
            >
              {e}
            </th>
          ))}
        </tr>
      </thead>
    );
  }

  function rowUI({
    topic, solved, total,
  }, key) {
    const coverage = Math.min(100, (solved / total) * 100);

    return (
      <tr key={key} className="profile-problem-stat__row">
        <td className="profile-problem-stat__row-cell">
          {topic}
        </td>
        <td className="profile-problem-stat__row-cell">
          <div className="profile-problem-stat__cell-row">
            <Progressbar
              limit={100}
              value={coverage}
              className="profile-problem-stat__progress-bar"
              renderValue={false}
              progressbarClassName="profile-problem-stat__progress-bar-text"
            />
            <span>
              {`${coverage.toFixed(1)} %`}
            </span>
          </div>

        </td>
        <td className="profile-problem-stat__row-cell">
          <span>
            {`${solved}/ ${total}`}
          </span>
        </td>
      </tr>
    );
  }

  return (
    <div className="profile-problem-stat">
      <h3 className="profile-problem-stat__title">
        Topic Specific Problem Stats
      </h3>
      {
        profileACL.isPrivate()
          ? (
            <p className="profile-problem-stat__subtitle">
              Only topics with 50% coverage or more are
              shown in your public profile.
            </p>
          )
          : null
      }
      <div className="profile-problem-stat__container">
        <table
          className="profile-problem-stat__table"
          cellSpacing={0}
          cellPadding={0}
        >
          {headerUI()}
          <tbody>
            {data.map(rowUI)}
          </tbody>
        </table>
      </div>
    </div>
  );
}

ProblemStat.propTypes = {
  topicStats: propTypes.arrayOf(propTypes.shape({
    topic: propTypes.string.isRequired,
    solved: propTypes.number,
    total: propTypes.number,
  })),
};

export default ProblemStat;
